import { NAF } from '@/shared/constants/naf';

const map = new Map(NAF);

export function getNaf(nafCode) {
  return map.get(nafCode);
}
